export default __webpack_public_path__ + "static/media/pluck.5de12e3c.mp3";